import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { SPACING_SIZES } from './commons';
import { tokenToPx } from './getToken';

export const tabsTheme: Components = {
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: '49px',
        '& .MuiTabs-indicator': {
          // reset MuiTabs indicator for better control
          height: '0px',
          backgroundColor: 'none'
        },
        '&.tab-variant': {
          color: tokens.colorOnSurface,
          borderBottom: `1px solid ${tokens.colorSurfaceVariant}`,
          '& .Mui-selected': {
            position: 'relative',
            color: tokens.colorOnSurface,
            zIndex: 0,
            '&::before': {
              content: '""',
              position: 'absolute',
              zIndex: -1,
              left: 0,
              right: 0,
              bottom: 0,
              height: '4px',
              backgroundColor: tokens.colorPrimary,
              borderRadius: '4px 4px 0 0'
            }
          }
        },
        '&.nav-variant': {
          backgroundColor: tokens.colorSurface,
          color: tokens.colorOnSurface,
          fontSize: tokenToPx('bodyMediumFontSize'),
          '& .MuiButtonBase-root': {
            minWidth: '90px',
            maxWidth: '360px',
            padding: `6px ${SPACING_SIZES.l}`,
            borderRadius: tokens.radiusDefault,
            '&:hover': {
              backgroundColor: 'rgba(26, 26, 26, 0.08)'
            },
            '&:focus': {
              backgroundColor: 'rgba(26, 26, 26, 0.12)'
            },
            '&.Mui-selected, &.selected, &.active': {
              backgroundColor: tokens.colorSecondaryContainer,
              color: tokens.colorOnSecondaryContainer,
              position: 'relative',
              '&:hover::before': {
                content: '""',
                position: 'absolute',
                width: '100%',
                height: '100%',
                backgroundColor: tokens.statePrimaryHoverStateLayerColor
              }
            },
            '&.Mui-disabled': {
              backgroundColor: 'rgba(26, 26, 26, 0.12)'
            }
          }
        }
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'initial'
      }
    }
  }
} satisfies Components;
